import 'jquery';
import Variables from './Variables';
import Utility from './Utility';

const preloadImages = function (images) {
  for (let i = 0; i < images.length; i++) {
    const image = new Image();
    image.src = images[i];
  }
};

const FlyoutImageMenu = (() => {
  return {
    initialize(settings) {
      const $nav = $(settings.nav);
      if (!$nav.length) {
        return;
      }
      const $menuItems = $nav.find('ul:first > li >').find(`a[${settings.image.left}], a[${settings.image.right}]`);

      // Preload images to prevent flickering
      $(window).load(function () {
        const images = [];
        $menuItems.each(function (index, element) {
          const $element = $(element);
          const imageLeft = $element.attr(settings.image.left);
          const imageRight = $element.attr(settings.image.right);
          if (typeof imageLeft !== 'undefined') {
            images.push(imageLeft);
          }
          if (typeof imageRight !== 'undefined') {
            images.push(imageRight);
          }
        });
        preloadImages(images);
      });

      let $imageElements = [];
      $menuItems.mouseout(function () {
        $imageElements.forEach($image => {
          $image.remove();
        });
        $imageElements = [];
      });

      $menuItems.mouseover(function () {
        if (Utility.getViewport().width < Variables.breakpoints.desktop) {
          return;
        }

        const $element = $(this);
        const imageLeft = $element.attr(settings.image.left);
        const imageRight = $element.attr(settings.image.right);

        if (typeof imageLeft !== 'undefined') {
          const $imageLeft = $('<img />').addClass('flyout-menu-image flyout-menu-image--left').attr('src', imageLeft);
          $imageElements.push($imageLeft);
          $element.parent().before($imageLeft);
        }

        if (typeof imageRight !== 'undefined') {
          const $imageRight = $('<img />').addClass('flyout-menu-image flyout-menu-image--right').attr('src', imageRight);
          $imageElements.push($imageRight);
          $element.parent().after($imageRight);
        }
      });
    },
  };
})();

export default FlyoutImageMenu;



// WEBPACK FOOTER //
// ./scripts/App/FlyoutImageMenu.js